import React from 'react';
import { number, shape, string, bool } from 'prop-types';
import Teaser from 'components/Teaser';

import { MQ_MEDIUM, MQ_LARGE, MQ_MIDLARGE, MQ_SMALL_ONLY } from 'constants/mq';
import styles from './styles';

// We assume the roundup teasers are in posts and size them accordingly
const SOURCE_SETS = [
  {
    layoutWidth: { value: 730, units: 'px' },
    imageDims: { height: 730, width: 730 },
    media: MQ_MIDLARGE
  },
  {
    layoutWidth: { value: 610, units: 'px' },
    imageDims: { height: 610, width: 610 },
    media: MQ_LARGE
  },
  {
    layoutWidth: { value: 696, units: 'px' },
    imageDims: { height: 696, width: 696 },
    media: MQ_MEDIUM
  },
  {
    layoutWidth: { value: 343, units: 'px' },
    imageDims: { height: 343, width: 343 },
    media: MQ_SMALL_ONLY
  }
];

export function RecipeRoundupTeaser(props) {
  const {
    postId,
    description,
    postUrl,
    roundupStats,
    teaserImage,
    porkchopId,
    title,
    imageCredit,
    isExternal
  } = props;

  const gtmAttrs = {
    'data-gtm-porkchop-name': title,
    'data-gtm-porkchop-id': porkchopId,
    'data-gtm-porkchop-is-external': isExternal
  };

  return (
    <div className="RecipeRoundup__recipe">
      <style jsx>{styles}</style>
      <div className="Teaser--RecipeRoundup__number">
        {roundupStats.number} / {roundupStats.roundupTotal}
      </div>
      <Teaser
        headline={title}
        imageUrl={teaserImage}
        dek={description}
        cta="Go To The Recipe"
        variant="recipeRoundup"
        fallbackDims={{
          width: 100,
          height: 100
        }}
        gtmAttrs={gtmAttrs}
        placeholders={[{ media: '(min-width: 0)', ratio: 1 }]}
        sourceSets={SOURCE_SETS}
        url={postUrl}
        credit={imageCredit}
        recipeId={porkchopId}
        postId={postId}
        postUrl={postUrl}
      />
    </div>
  );
}

RecipeRoundupTeaser.propTypes = {
  roundupStats: shape({
    number: number.isRequired,
    roundupTotal: number.isRequired
  }).isRequired,
  porkchopId: string.isRequired,
  postId: string.isRequired,
  title: string.isRequired,
  teaserImage: string.isRequired,
  description: string,
  postUrl: string.isRequired,
  imageCredit: string,
  isExternal: bool
};

RecipeRoundupTeaser.defaultProps = {
  description: '',
  imageCredit: undefined,
  isExternal: false
};

export default RecipeRoundupTeaser;
